// extracted by mini-css-extract-plugin
export default {"floatingButton":"styles_floatingButton__vB1n3","floatingContainer":"styles_floatingContainer__PUjVI"};